import React,{useState,useEffect,useContext, useReducer} from 'react'
import logo from '../../images/logo.png'
import { Link } from "react-router-dom";
import Menu from './Menu';
import {MenuProvider,initialState, MenuReducer} from '../../components/Context/MenuContext';
import Cart from '../shop/Cart';

let style={
    height:"70px",
    textAlign:"left"
}

export default function Header({props}) {
    const [state, dispatch] = useReducer(MenuReducer, initialState)
    return (
            <div style={style} className="container">
                <div className="row">
                    <div className="col-lg-2 col-md-3 col-sm-12 col-xs-12" style={{maxHeight:"100%",textAlign:"center"}}>
                        <Link to="/"> 
                        <img src={logo} alt="" style={{height:"100%",maxHeight:"55px",marginTop:"5px" }} /> 
                        </Link>
                    </div>
                    
                    <div className="col-lg-10 col-md-9 d-none d-md-block" style={{textAlign:"right"}}>
                        <MenuProvider value={{state, dispatch}}>
                            <Menu></Menu>
                        </MenuProvider>
                        <Cart></Cart>
                    </div>
                </div>
            </div>
   
    )
}
